<template lang="pug">
  .component-google-map-search-box
    input.input.controls(:id="this._uid+'-search-input'", type='text', placeholder='Search...')
</template>

<script>
  import GoogleMapChildren from './GoogleMapChildren'

  export default {
    name: 'GoogleMapSearchBox',
    extends: GoogleMapChildren,
    data() {
      return {
        searchBox: null
      }
    },
    mounted() {
      if (!this.embeddedOnMap && this.item == null) {
        this.createGoogleMaps().then(() => {
          this.init()
        })
      }

    },
    methods: {
      createGoogleMaps() {
        var self = this
        return new Promise((resolve, reject) => {
          if (document.getElementById('google-map-loader') === null) {
            let gmap = document.createElement('script')
            gmap.setAttribute('id', 'google-map-loader')
            gmap.src = self.url
            gmap.type = 'text/javascript'
            gmap.onload = resolve
            gmap.onerror = reject
            document.body.appendChild(gmap)
          } else {
            resolve()
          }
        })
      },
      init: function () {
        const input = document.getElementById(this._uid + '-search-input')
        const searchBox = new google.maps.places.SearchBox(input)
        if (this.embeddedOnMap) {
          this.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(input)
          this.getMap().addListener('bounds_changed', () => {
            searchBox.setBounds(this.getMap().getBounds())
          })
        }
        searchBox.addListener('places_changed', () => {
          const place = searchBox.getPlaces()[0]
          this.$emit('placesChanged', place)
        })
      }
    },
    props: {
      embeddedOnMap: {
        type: Boolean,
        default: false
      },
      apiKey: {
        type: String
      }
    },
    computed: {
      url() {
        return this.proxyUrl && this.proxyUrl !== '' ? this.proxyUrl : `https://maps.googleapis.com/maps/api/js?key=${window.env.GOOGLE_MAPS_KEY}&libraries=places,visualization`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GoogleMapSearchBox.vue?00a5e389